import { Inject, Injectable } from '@angular/core';

import { SdkMessageHandler, SdkMessageHandlerCallback } from './../../../../api';
import { createUnsubscribeHandler } from './../../../../utils';
import { WchLoggerService } from './../../logger/wch.logger.service';

/* Copyright IBM Corp. 2018 */
const LOGGER = 'SdkUnsubscribeHandler';

/**
 * Subscribes to the active route
 */
@Injectable()
export class SdkUnsubscribeHandler implements SdkMessageHandler {

    handle: SdkMessageHandlerCallback;

    constructor(@Inject(WchLoggerService) loggerService: WchLoggerService) {
        // attach
        this.handle = createUnsubscribeHandler(loggerService.get(LOGGER));
    }
}
